// extracted by mini-css-extract-plugin
module.exports = {"lang":"Lang_lang__167da","langBtn":"Lang_langBtn__1pf7W","selected":"Lang_selected__1RDQt"};